import { combineReducers } from 'redux';
import lobbyReducer from './lobbyReducer.js';
import accountReducer from './accountReducer.js';
import sessionStateReducer from './sessionStateReducer.js';

export default combineReducers({
  profile: accountReducer,
  lobbyInfo: lobbyReducer,
  sessionState: sessionStateReducer,
});